<template>
    <nav class="navbar navbar-expand-sm navbar-dark bg-dark justify-content-between"
        style="height:65px; z-index: 99999; position: fixed; width: 100%; top: 0;">
        <a class="navbar-brand">P5管理後台</a>
        <ul class="navbar-nav">
            <li>
                <h2 class="text-light pt-2 mr-3">Hello! <span class="font-italic font-weight-bolder">{{ name }}</span></h2>
            </li>
            <li>
                <admin-register></admin-register>
            </li>
            <li>
                <logout></logout>
            </li>
        </ul>
    </nav>
</template>

<script>
export default {
    data() {
        return {
            name: "",
            base_url
        }
    },
    mounted() {
        this.getAdmin();

    },
    methods: {
        getAdmin() {
            axios
                .get(base_url + '/admin/api/username')
                .then((response) => {
                    this.name = response.data.username
                    console.log(response);
                })
                .catch(function (error) {
                    console.error(error);
                });
        }
    }
}
</script>
